export interface ROHistory {
    RO: string;
    date: string;
    price: string;
    advisor: string;
    odometer: string;
    comments: string;
    recommendations: string;
    detail: ROHistoryDetail[];
    rnddeArray: RNDDEData[];
    campaignArray: histCampaign[];
}

interface ROHistoryDetail {
    opCode: string;
    opDesc: string;
    price: string;
    concern: string;
    cause: string;
    correction: string;
    cwi: string;
    complaint: string;
    warrantyClaimNum: string;
    warrantyOp: string;
    technicians: string[];
}

interface RNDDEData {
    rndOpDesc: string;
    rndComplaint: string;
    rndCause: string;
    rndComments: string;
    rndRefusalCode: string;
    rndRefusalCodeDesc: string;
    rndRefusalCodeDueDate: string;
}

interface histCampaign {
    campDesc: string;
    campNum: string;
}

interface NSHDetails {
    svcDescOrderNotes: string[];
    svcStatus: string[];
}

export interface NSHData {
    nshDetails: NSHDetails[];
    errMsg: string;
}

export interface ROHistoryData {
    built: boolean;
    roHistory: ROHistory[];
    errMsg?: string;
    nshData: NSHData;
}
// changes made here effect multiple test files. Be careful when doing anything but adding to.
export const TestROHistory: ROHistoryData = {
    built: true,
    roHistory: [
        {
            RO: '12345',
            date: '01/02/20',
            price: '99.99',
            advisor: 'RICK GRIMES',
            odometer: '46000',
            comments: 'comment',
            recommendations: 'recomm',
            detail: [
                {
                    opCode: '01FOZZ',
                    opDesc: 'OIL CHANGE',
                    price: '10.00',
                    concern: 'TEST CONCERN',
                    cause: 'TEST CAUSE',
                    correction: 'TEST CORRECTION',
                    cwi: 'C',
                    complaint: 'broken thing',
                    warrantyClaimNum: '',
                    warrantyOp: '',
                    technicians: [],
                },
                {
                    opCode: '99FOZZ',
                    opDesc: 'LUBE SPECIAL',
                    price: '99.99',
                    concern: 'CONCERNING',
                    cause: 'CAUSING',
                    correction: 'CORRECTING',
                    cwi: 'W',
                    complaint: 'broken thing',
                    warrantyClaimNum: '',
                    warrantyOp: '',
                    technicians: [],
                },
                {
                    opCode: '99FOZZ1',
                    opDesc: 'LUBE SPECIAL',
                    price: '99.99',
                    concern: 'CONCERNING',
                    cause: 'CAUSING',
                    correction: 'CORRECTING',
                    cwi: 'W',
                    complaint: 'broken thing',
                    warrantyClaimNum: '1',
                    warrantyOp: '',
                    technicians: [],
                },
                {
                    opCode: '99FOZZ2',
                    opDesc: 'LUBE SPECIAL',
                    price: '99.99',
                    concern: 'CONCERNING',
                    cause: 'CAUSING',
                    correction: 'CORRECTING',
                    cwi: 'W',
                    complaint: 'broken thing',
                    warrantyClaimNum: '1',
                    warrantyOp: '1',
                    technicians: [],
                },
                {
                    opCode: '99FOZZ3',
                    opDesc: 'LUBE SPECIAL',
                    price: '99.99',
                    concern: 'CONCERNING',
                    cause: 'CAUSING',
                    correction: 'CORRECTING',
                    cwi: 'W',
                    complaint: 'broken thing',
                    warrantyClaimNum: '',
                    warrantyOp: '',
                    technicians: [],
                },
                {
                    opCode: '03FOZZ',
                    opDesc: 'TIRE ROTATION',
                    price: '200.00',
                    concern: 'X',
                    cause: 'Y',
                    correction: 'Z',
                    cwi: 'I',
                    complaint: 'broken thing',
                    warrantyClaimNum: '1',
                    warrantyOp: '',
                    technicians: [],
                },
                {
                    opCode: '',
                    opDesc: '',
                    price: '',
                    concern: '',
                    cause: '',
                    correction: '',
                    cwi: '',
                    complaint: '',
                    warrantyClaimNum: '',
                    warrantyOp: '',
                    technicians: [],
                },
            ],
            rnddeArray: [{
                rndOpDesc: '',
                rndComplaint: '',
                rndCause: '',
                rndComments: 'test',
                rndRefusalCode: 'RN',
                rndRefusalCodeDesc: '',
                rndRefusalCodeDueDate: '',
            }],
            campaignArray: [{
                campDesc: 'Web campaign',
                campNum: '15',
            }],
        },
        {
            RO: '11111',
            date: '01/02/11',
            price: '11.11',
            advisor: 'LORI GRIMES',
            odometer: '45480',
            comments: '',
            recommendations: '',
            detail: [
                {
                    opCode: '01FOZZ',
                    opDesc: 'OIL CHANGE',
                    price: '10.00',
                    concern: 'TEST CONCERN',
                    cause: 'TEST CAUSE',
                    correction: 'TEST CORRECTION',
                    complaint: 'broken thing',
                    warrantyClaimNum: '2',
                    warrantyOp: '2',
                    technicians: [],
                    cwi: 'C',
                },
            ],
            rnddeArray: [{
                rndOpDesc: 'not recommended description',
                rndComplaint: 'too tall',
                rndCause: 'grew to big',
                rndComments: '',
                rndRefusalCode: 'RN',
                rndRefusalCodeDesc: 'done next visit',
                rndRefusalCodeDueDate: '01/22/22',
            },
            {
                rndOpDesc: '',
                rndComplaint: '',
                rndCause: '',
                rndComments: 'test',
                rndRefusalCode: '',
                rndRefusalCodeDesc: '',
                rndRefusalCodeDueDate: '',
            }],
            campaignArray: [{
                campDesc: 'Web campaign',
                campNum: '15',
            }, {
                campDesc: 'wabbit hunting',
                campNum: '123222212',
            }],
        },
        {
            RO: '11112',
            date: '01/02/11',
            price: '11.11',
            advisor: 'LORI GRIMES',
            odometer: '45480',
            comments: '',
            recommendations: 'recomm fish biscuit',
            detail: [
                {
                    opCode: '01FOZZ',
                    opDesc: 'OIL CHANGE',
                    price: '10.00',
                    concern: 'TEST CONCERN',
                    cause: 'TEST CAUSE',
                    correction: 'TEST CORRECTION',
                    complaint: 'broken thing',
                    warrantyClaimNum: '2',
                    warrantyOp: '2',
                    technicians: [],
                    cwi: 'C',
                },
            ],
            rnddeArray: [],
            campaignArray: [],
        },
    ],
    nshData: {
        nshDetails: [],
        errMsg: '',
    },
};